import { DEFAULT_LANGUAGE } from '@procureai/schemas';
import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { AstroLanguage, Currency } from '@/generated/gql/graphql';

export const userProfileFormSchema = z.object({
  capabilityIds: z.array(z.string()).nullable(),
  commodityGroupIds: z.array(z.string()).nullable(),
  workingHours: z.number().min(0).nullable(),
  pictureId: z.string().nullable(),
  deliveryLocationId: z.string().nullable(),
  organizationId: z.string().nullable(),
  accountingAreaId: z.string().nullable(),
  costCenterId: z.string().nullable(),
  currency: z.enum(Currency),
  language: z.enum(AstroLanguage).nullable(),
});

export type UserProfileFormData = z.infer<typeof userProfileFormSchema>;

export const userProfileFormDataDefault: DefaultValues<UserProfileFormData> = {
  capabilityIds: [],
  commodityGroupIds: [],
  workingHours: null,
  pictureId: null,
  organizationId: null,
  deliveryLocationId: null,
  currency: Currency.EUR,
  accountingAreaId: null,
  costCenterId: null,
  language: AstroLanguage[DEFAULT_LANGUAGE],
};
